export const ParameterKeys = {
  dayKey: 'dag-',
};
